import buffer from 'buffer'
;(window as any).global = window
// @ts-ignore
window.Buffer = window.Buffer || buffer.Buffer
